import { render, staticRenderFns } from "./addSupplement.vue?vue&type=template&id=56dcc42c&"
import script from "./addSupplement.vue?vue&type=script&lang=js&"
export * from "./addSupplement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports